import React, { useState, MouseEventHandler } from "react"
import { isMobile } from "react-device-detect"
import PhotoCamera from "@mui/icons-material/PhotoCamera"
import ArrowForwardIcon from "@mui/icons-material/ArrowForward"
import styles from "./ButtonWithCamera.module.scss"

interface Props {
  color: string
  text: string
  onClick: MouseEventHandler
}
/**
 * カメラアイコン付きボタン
 * @param {string} color - ボタンの色
 * @param {string} text - ボタン上に表示する文言
 * @param {MouseEventHandler} onClick - ボタン押下時の処理
 */
const ButtonWithCamera = ({ color, text, onClick }: Props) => {
  const [isTap, setIsTap] = useState(false)
  const tapOrHover = `${isMobile ? "" : styles.hover} ${isTap ? styles.onTap : ""}`
  return (
    <div
      className={`${styles.button} ${tapOrHover}`}
      style={{ backgroundColor: color }}
      onClick={onClick}
      onTouchStart={() => {
        setIsTap(true)
      }}
      onTouchEnd={() => {
        setIsTap(false)
      }}
      aria-hidden="true"
    >
      <PhotoCamera className={styles.iconCamera} />
      <span className={styles.button__text}>{text}</span>
      <ArrowForwardIcon className={styles.iconArrowForward} />
    </div>
  )
}
export default ButtonWithCamera
